import React from 'react';
import { Hero } from '../components/Hero';
export function HomePage() {
  return <main data-id="element-228">
      <Hero data-id="element-229" />
    </main>;
}